// Token storage keys
export const TOKEN_KEY = 'cnxn_token';
export const ADMIN_TOKEN_KEY = 'cnxn_admin_token';

// User storage keys
export const USER_KEY = 'cnxn_user';
export const ADMIN_USER_KEY = 'cnxn_admin_user';

// Auth-related constants
export const AUTH_ROLES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super',
  USER: 'user'
};